<div class="icon-container w-100 h-100">
    <img class="sunrays" alt="sunrays" title="sunrays"  src="../../../assets/icons/sunglare.svg"/>
    <div class="sun-mask">
        <img alt="dark-mode" title="dark-mode" class="w-100 h-100 moon" src="../../../assets/icons/moon.svg"/>
        <img alt="day-mode" title="day-mode" class="w-100 h-100 sun" src="../../../assets/icons/sun.svg"/>
    </div>
</div>